import { createBrowserRouter } from 'react-router-dom';
import App from './App';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/artigo/:slug',
        element: <App />
      },
      {
        path: '/categoria/:category',
        element: <App />
      }
    ]
  }
]);
